import websitePage, { HEADER_TYPE_WITH_MENU_AND_APPLICATION } from '../../hoc/websitePage/websitePage';
import Benefits from '../../screens/Benefits/Benefits';
import { getAllBenefits } from '../../service/cms/getBenefitsPageContent';

export async function getStaticProps() {
  const allBenefits = await getAllBenefits();

  return {
    props: {
      benefitsNu: allBenefits.benefitsNuSection.benefits,
      benefitsMastercard: allBenefits.benefitsMastercardSection.benefits,
      categories: [{ name: 'Todos', id: 'ALL' }, ...allBenefits.allBenefitsCategories],
    },
  };
}

export default websitePage(Benefits, {
  routeKey: 'BENEFITS',
  header: HEADER_TYPE_WITH_MENU_AND_APPLICATION,
  btnVisibleScrolling: true,
  buttonLabel: 'HOME.HERO.BUTTON_LABEL.MULTIPRODUCT',
});
